import { createRoutine } from 'redux-saga-routines';
import extendRoutine from 'utils/routines';

import { GET_TOPICS } from './constants';

export const getTopics = extendRoutine(createRoutine(GET_TOPICS), 'RESET');
